const DOCUMENT_BY_THEME = {
  esn: {
    icon: './esn-icon.png',
    title: 'ESN - Escola Superior de Educação e Negócios',
  },
  u4: {
    icon: './u4-icon.png',
    title: 'Unifour University',
  },
  uca: {
    icon: './uca-icon.png',
    title: 'AVA - Faculdade Católica Paulista',
  },
}

/**
 * Resolve o tema institucional (uca | esn | u4) a partir de build, storage ou host.
 */
export function resolveTheme() {
  let theme = process.env?.VUE_APP_MODE ?? null

  if (!theme && ['development', 'homologation'].includes(process.env.NODE_ENV)) {
    theme = window.localStorage.getItem('theme') ?? 'uca'
  }

  if (!theme) {
    const host = window.location.host.toString().toLowerCase()
    if (host.includes('esn')) {
      theme = 'esn'
    } else if (host.includes('unifouruniversity')) {
      theme = 'u4'
    } else {
      theme = 'uca'
    }
  }

  return theme
}

/** Favicon e título do documento conforme o tema (após o bundle carregar). */
export function applyDocumentTheme(theme = resolveTheme()) {
  const config = DOCUMENT_BY_THEME[theme] ?? DOCUMENT_BY_THEME.uca
  document.title = config.title
  const link = document.querySelector('link[rel="icon"]')
  if (link) {
    link.setAttribute('href', config.icon)
  }
}
